import { jsxs, jsx } from "react/jsx-runtime";
const IllustrationWarningSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.705 9.528c2.784-4.871 9.806-4.871 12.59 0l22.214 38.875c2.762 4.833-.728 10.847-6.294 10.847H9.785c-5.566 0-9.056-6.014-6.294-10.847L25.705 9.528Z",
          fill: "#F9E2B6",
          stroke: "#DEB567",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.583 14.613c1.559-2.56 5.275-2.56 6.834 0L56.299 48.92c1.623 2.666-.296 6.08-3.416 6.08H11.117c-3.12 0-5.039-3.414-3.416-6.08l20.882-34.307Z",
          fill: "#FCF5D7"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M32.204 26c1.063 0 1.917.873 1.894 1.935l-.253 11.824a1.644 1.644 0 0 1-3.288-.001l-.247-11.824A1.894 1.894 0 0 1 32.204 26ZM32.2 48c-.607 0-1.127-.227-1.56-.68-.427-.454-.64-1.006-.64-1.658 0-.638.213-1.183.64-1.637.433-.453.953-.68 1.56-.68.593 0 1.107.227 1.54.68.44.454.66 1 .66 1.637 0 .432-.103.825-.31 1.18-.2.354-.467.637-.8.85A2.01 2.01 0 0 1 32.2 48Z",
          fill: "#132B3E"
        }
      )
    ]
  }
);
export {
  IllustrationWarningSvg
};
